export const SET_USER_PROFILE_DATA = 'SET_USER_PROFILE_DATA';
export const MODULE_NAME = 'userProfileData';
